import { useState, type FC } from "react";
import { InflationResult, InflationStepperProps } from "./InflationStepper.types";
import { Fail } from "./Pages/Fail";
import { Form } from "./Pages/Form";
import { Processing } from "./Pages/Processing";
import { Recap } from "./Pages/Recap";
import { Success } from "./Pages/Success";

export const InflationStepper: FC<InflationStepperProps> = (props) => {
    const [pageIndex, setPageIndex] = useState(0);
    const [formResult, setFormResult] = useState<InflationResult | null>(null);

    switch (pageIndex) {
        case 0:
            return <Form {...props} setFormResult={setFormResult} setPageIndex={setPageIndex} />;
        case 1:
            return <Recap {...props} setPageIndex={setPageIndex} formResult={formResult} />;
        case 2:
            return <Processing {...props} setPageIndex={setPageIndex} formResult={formResult} />;
        case 3:
            return <Success {...props} setPageIndex={setPageIndex} />;
        case 4:
            return <Fail {...props} setPageIndex={setPageIndex} />;
    }
};
